export var getCardCcvForUpdate=function getCardCcvForUpdate(ccv,cardType){var value=ccv.replace(/\D/g,"");//take out all but numbers
if(cardType){value=value.substring(0,cardType.code.size);//take out extra characters
}return value;};